import { SerializedField } from '@components/ContentDefinitionSchemaEditor/FieldSerializer/types';
import { observer } from 'mobx-react';
import React from 'react';
import {
    arrayItemIndexingMappedErrors,
    translatableMappedErrors
} from '../../../../services/FormUtils/DefinitionFieldMappedErrors';
import { ArrayConstraints } from '../../FieldSerializer/fields/array';
import { FieldEditTabProps } from '../../types';
import IndexingAttribute from '../Constraints/Indexing';
import TranslatableAttribute from '../Constraints/TranslatableAttribute';
import ArrayAdditionalDetails from './index';

function ListOfItemsDetails(props: FieldEditTabProps<ArrayConstraints>) {
    return (
        <>
            <IndexingAttribute
                relatedTabKey={'detailsTab'}
                mappedErrors={arrayItemIndexingMappedErrors}
                type={props.fieldEditorStore.serializedField!.constraints.items.type}
                value={(props.fieldEditorStore.serializedField!.constraints.items as any)['enableFacet']}
                onChange={props.fieldEditorStore.updateEnableFacet}
            />
            {props.fieldEditorStore.isTranslatableField(props.constraints.items as SerializedField) &&
                <TranslatableAttribute
                    relatedTabKey={'detailsTab'}
                    mappedErrors={translatableMappedErrors}
                    value={(props.constraints.items as any)['translatable']}
                    type={props.fieldEditorStore.serializedField!.constraints.items.type}
                    onChange={props.fieldEditorStore.updateTranslatableAttribute}
                />
            }
            <ArrayAdditionalDetails
                id={'ArrayAdditionalDetails'}
                isArrayChildren={true}
                fieldToRenderType={props.fieldEditorStore.serializedField!.editingSubType!}
                fieldEditorStore={props.fieldEditorStore}
                defaultLang={props.defaultLang}
                constraints={props.constraints.items.constraints}
                onChangeConstraint={props.fieldEditorStore.updateArrayItemsConstraint}
            />
        </>
    );
}

export default observer(ListOfItemsDetails);
